import React from 'react';
import { Box } from '@mui/material';
import Header from './components/Header';
import Hero from './components/Hero';
import SensitivityDemo from './components/SensitivityDemo';
import ScenarioSimulator from './components/ScenarioSimulator';
import FileManagerShowcase from './components/FileManagerShowcase';
import UkFeaturesGrid from './components/UkFeaturesGrid';
import BetaSignup from './components/BetaSignup';
import Footer from './components/Footer';

function App() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Header />
      <Box component="main" role="main">
        <Hero />
        <SensitivityDemo />
        <ScenarioSimulator />
        <FileManagerShowcase />
        <UkFeaturesGrid />
        <BetaSignup />
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
